// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `header {
  height: 5rem;
  background-color: white;
  position: fixed;
  z-index: 100;
  top: 0;
}

.header-logo {
  width: 3rem;
}

.title-nav {
  font-weight: 400;
  font-size: 1.5rem;
  margin-left: 1rem;
  padding-top: 0.5rem;
  vertical-align: middle;
}

.bg-image {
  width: 100%;
  height: 100%;
}

.header-notifications {
  font-size: 1.35rem !important;
}

.header-notifications img {
  height: 2rem;
}

.header-notifications-number {
  font-size: 0.7rem !important;
  width: 1rem;
  height: 1rem;
  border-radius: 50% !important;
  right: 0.7rem;
  top: 0.5rem !important;
}

.header-logged-user {
  display: flex !important;
  flex-direction: row;
  justify-content: center;
  align-items: center;
}

.header-logged-user > div,
.header-logged-user > span {
  font-size: 1.35rem;
}

.header-logged-user img {
  height: 2rem;
}

.notification-panel {
  width: 360px;
}

.spinner-border-xs {
  width: 0.6rem !important;
  height: 0.6rem !important;
  border-width: 0.1rem !important;
}

.dropdown-item img {
  height: 2rem;
  padding: 0.3rem;
  vertical-align: middle;
}`, "",{"version":3,"sources":["webpack://./src/components/Shared/Header/Header.scss"],"names":[],"mappings":"AAAA;EACE,YAAA;EACA,uBAAA;EACA,eAAA;EACA,YAAA;EACA,MAAA;AACF;;AAEA;EACE,WAAA;AACF;;AAEA;EACE,gBAAA;EACA,iBAAA;EACA,iBAAA;EACA,mBAAA;EACA,sBAAA;AACF;;AAEA;EACE,WAAA;EACA,YAAA;AACF;;AAEA;EACE,6BAAA;AACF;;AAEA;EACE,YAAA;AACF;;AAEA;EACE,4BAAA;EACA,WAAA;EACA,YAAA;EACA,6BAAA;EACA,aAAA;EACA,sBAAA;AACF;;AAEA;EACE,wBAAA;EACA,mBAAA;EACA,uBAAA;EACA,mBAAA;AACF;;AAEA;;EAEE,kBAAA;AACF;;AAEA;EACE,YAAA;AACF;;AAEA;EACE,YAAA;AACF;;AACA;EACE,wBAAA;EACA,yBAAA;EACA,+BAAA;AAEF;;AACA;EACE,YAAA;EACA,eAAA;EACA,sBAAA;AAEF","sourcesContent":["header {\n  height: 5rem;\n  background-color: white;\n  position: fixed;\n  z-index: 100;\n  top: 0;\n}\n\n.header-logo {\n  width: 3rem;\n}\n\n.title-nav {\n  font-weight: 400;\n  font-size: 1.5rem;\n  margin-left: 1rem;\n  padding-top: 0.5rem;\n  vertical-align: middle;\n}\n\n.bg-image {\n  width: 100%;\n  height: 100%;\n}\n\n.header-notifications {\n  font-size: 1.35rem !important;\n}\n\n.header-notifications img {\n  height: 2rem;\n}\n\n.header-notifications-number {\n  font-size: 0.7rem !important;\n  width: 1rem;\n  height: 1rem;\n  border-radius: 50% !important;\n  right: 0.7rem;\n  top: 0.5rem !important;\n}\n\n.header-logged-user {\n  display: flex !important;\n  flex-direction: row;\n  justify-content: center;\n  align-items: center;\n}\n\n.header-logged-user > div,\n.header-logged-user > span {\n  font-size: 1.35rem;\n}\n\n.header-logged-user img {\n  height: 2rem;\n}\n\n.notification-panel {\n  width: 360px;\n}\n.spinner-border-xs {\n  width: 0.6rem !important;\n  height: 0.6rem !important;\n  border-width: 0.1rem !important;\n}\n\n.dropdown-item img {\n  height: 2rem;\n  padding: 0.3rem;\n  vertical-align: middle;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
